import { render, staticRenderFns } from "./FormLottery.vue?vue&type=template&id=0d63cfa0&scoped=true&"
import script from "./FormLottery.vue?vue&type=script&lang=js&"
export * from "./FormLottery.vue?vue&type=script&lang=js&"
import style0 from "./FormLottery.vue?vue&type=style&index=0&id=0d63cfa0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d63cfa0",
  null
  
)

export default component.exports